class JWToken {
  constructor (customerId) {
    this.customerId = customerId
  }


  async getToken (options = {}) {
    const forceRefresh = Boolean(options.forceRefresh)

    if (forceRefresh) {
      await this.refreshFromNetwork()
      console.log(this.token)
      return this.token
    }

    if (!this.token || !this.timestamp) {
      await this.loadFromCache()
    }

    let now = +new Date() / 1000
    let elapsed = now - this.timestamp

    // Expire tokens both after 15 minutes and when the device clock moves backwards.
    if (elapsed < 0 || elapsed > 300) {
      await this.refreshFromNetwork()
    }

    console.log(this.token)
    return this.token
  }

  async loadFromCache () {
    let storedToken = localStorage.getItem(
      'expertifyToken_' + String(this.customerId)
    )
    if (storedToken == null) {
      console.log('1111')
      storedToken = await this.getNewToken()
    }

    try {
      this.applyStoredToken(storedToken)
    } catch (err) {
      storedToken = await this.getNewToken()
      this.applyStoredToken(storedToken)
    }
  }

  applyStoredToken (storedToken) {
    console.log(storedToken)
    let parsed = JSON.parse(storedToken)
    let parsedTimestamp = Number(parsed.timestamp)
    if (!parsed || !Number.isFinite(parsedTimestamp)) {
      throw new Error('Invalid cached JWT payload')
    }
    this.timestamp = parsedTimestamp
    this.token = parsed.token
  }

  async refreshFromNetwork () {
    let storedToken = await this.getNewToken()
    this.applyStoredToken(storedToken)
  }

  async getNewToken () {
    console.log('getting new token')
    let resp = await fetch('/apps/gifties-service/jwt?customerId=' + this.customerId)
    let parsed = await resp.json()
    let data = { token: parsed.token, timestamp: +new Date() / 1000 }
    localStorage.setItem(
      'expertifyToken_' + String(this.customerId),
      JSON.stringify(data)
    )
    return JSON.stringify(data)
  }
}
